<template>
  <div>
    <input ref="fileInput" type="file" style="display: none" @change="handleFileChange" />

    <div v-if="!selectedFile" class="file-picker-empty">
      <el-button type="primary" size="mini" @click="openFileDialog">
        Seleccionar archivo
      </el-button>
    </div>

    <div v-else class="file-picker-selected">
      <div class="file-info">
        <i class="el-icon-document"></i>
        <span class="file-name">{{ selectedFile.name }}</span>
      </div>
      <div class="file-actions">
        <el-button size="mini" type="primary" @click="openFileDialog"> Cambiar archivo </el-button>
        <el-button size="mini" type="danger" @click="removeFile"> Eliminar </el-button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

const emit = defineEmits<{
  (e: "input", value: File | null): void;
}>();
const fileInput = ref<HTMLInputElement>();
const selectedFile = ref<File | null>(null);

const openFileDialog = () => {
  fileInput.value?.click();
};

const handleFileChange = (event: Event) => {
  const file = (event.target as HTMLInputElement).files?.[0];
  if (file) {
    selectedFile.value = file;
    emit("input", file);
  }
};

const removeFile = () => {
  selectedFile.value = null;
  if (fileInput.value) {
    fileInput.value.value = "";
  }
  emit("input", null);
};
</script>

<style scoped>
.file-picker-empty {
  display: flex;
  justify-content: start;
}

.file-picker-selected {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 12px;
  background-color: #f5f7fa;
}

.file-info {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.file-info i {
  margin-right: 8px;
  color: #409eff;
  font-size: 16px;
}

.file-name {
  font-weight: 500;
  color: #303133;
  word-break: break-all;
}

.file-actions {
  display: flex;
  gap: 8px;
}
</style>
